import React from 'react';
import styled from 'styled-components';

const FeatureCard = ({ title, features }) => {
  return (
    <StyledWrapper>
      <div className="card">
        <p className="title">{title}</p>
        <ul className="lists">
          {features.map((feature, index) => (
            <li key={index} className="list">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <g strokeWidth={0} id="SVGRepo_bgCarrier" />
                <g strokeLinejoin="round" strokeLinecap="round" id="SVGRepo_tracerCarrier" />
                <g id="SVGRepo_iconCarrier">
                  <path
                    fill="#ffffff"
                    d="M21.5821 5.54289C21.9726 5.93342 21.9726 6.56658 21.5821 6.95711L10.2526 18.2867C9.86452 18.6747 9.23627 18.6775 8.84475 18.293L2.29929 11.8644C1.90527 11.4774 1.89956 10.8443 2.28655 10.4503C2.67354 10.0562 3.30668 10.0505 3.70071 10.4375L9.53911 16.1717L20.1679 5.54289C20.5584 5.15237 21.1916 5.15237 21.5821 5.54289Z"
                    clipRule="evenodd"
                    fillRule="evenodd"
                  />
                </g>
              </svg>
              <span>{feature}</span>
            </li>
          ))}
        </ul>
      </div>
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  .card {
    width: 100%;
    display: flex;
    flex-direction: column;
    border-radius: 1.5rem;
    background-color: #2a2a2a;
    padding: 2rem;
    box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.3);
    transition: all 0.3s ease;
    
    &:hover {
      background-color: #333333;
      transform: translateY(-5px);
    }
  }

  .title {
    font-size: 2rem;
    line-height: 1;
    font-weight: 600;
    color: #ffffff;
    margin-bottom: 1.5rem;
    text-align: center;
  }

  .lists {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    font-size: 1rem;
    line-height: 1.25rem;
    color: #999999;
  }

  .list {
    display: flex;
    align-items: center;
  }

  .list svg {
    height: 1rem;
    width: 1rem;
    fill: #ffffff;
  }

  .list span {
    margin-left: 1rem;
    font-size: 1.1rem;
  }
`;

export default FeatureCard; 